'use client';

import { BookDemoButton } from '@/components/ui';
import IndustryHero from '@/components/industry/IndustryHero';
import IndustryCommandCentre from '@/components/industry/IndustryCommandCentre';
import { useTranslation } from '@/hooks/useTranslation';

const BLUE = { color: 'var(--brand)' };
const DEEP = { color: 'var(--brand-deep)' };

/* Sector command-centre data — energy & utilities consumer operations.
   Sample/mock dashboard content (not marketing copy). */
const CC = {
  pulseTitle: 'Consumer & outage pulse',
  kpis: [
    { val: '1,540', lbl: 'Live mentions', live: true },
    { val: '120', lbl: 'Open escalations' },
    { val: '3.5m', lbl: 'Avg. first response' },
  ],
  sentiment: [
    { lbl: 'Positive', pct: 34, tone: 'positive' },
    { lbl: 'Neutral', pct: 35, tone: 'neutral' },
    { lbl: 'Negative', pct: 31, tone: 'negative' },
  ],
  sla: { pct: 80, lbl: 'SLA met' },
  tickerLabel: 'Incoming complaints',
  tickerItems: [
    { letter: 'V', text: 'No power since 4 hrs in sector 12', handle: '@vikram_r', tag: 'Outage', tagLevel: 'high' },
    { letter: 'N', text: 'Inflated bill after meter change', handle: '@neha_k', tag: 'Billing', tagLevel: 'med' },
    { letter: 'S', text: 'New connection delayed 10 days', handle: '@sanjay_m', tag: 'Connection', tagLevel: 'med' },
    { letter: 'D', text: 'Frequent tripping, no response', handle: '@divya_p', tag: 'Supply', tagLevel: 'high' },
  ],
  chips: [
    { variant: 'light', title: 'Outage cluster', sub: 'Spike detected in one grid zone' },
    { variant: 'dark', title: 'SignalSense alert', sub: 'Escalation predicted in 30 min' },
  ],
};

export default function EnergyHero() {
  const { t } = useTranslation();

  return (
    <IndustryHero
      layout="visual"
      breadcrumb={{
        ariaLabel: t('breadcrumb.breadcrumb'),
        label: t('footer.col.industries'),
        href: '/industries',
        current: t('Energy & Utilities'),
      }}
      title={
        <>
          {t('industries_energy_utilities.power_is_an_essential_service_so_is')}{' '}
          <span className="serif-accent italic">{t('industries_energy_utilities.energy_utilities_consumer_experienc')}</span>
          {' '}{t('industries_energy_utilities.for')}{' '}
          <span className="serif-accent italic">{t('industries_energy_utilities.utilities_renewable_developers_grid')}</span>.
        </>
      }
      lead={
        <>
          {t('industries_energy_utilities.when_a_transformer_fails_at_3_am_co')}{' '}
          <span style={BLUE}>{t('industries_energy_utilities.community_opposition')}</span>{t('industries_energy_utilities.it_trends_before_the_developers_com')}{' '}
          <span style={DEEP}>{t('industries_energy_utilities.locobuzz_intercepts_the_moment_it_s')}</span>
        </>
      }
      actions={<BookDemoButton label="Book a Personalised Energy & Utilities CX Demo" />}
      visual={<IndustryCommandCentre ariaLabel="Energy & utilities consumer command centre" {...CC} />}
    />
  );
}
